"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgGrid(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 0 14 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M19 19H5V5h14v14zM7 13v4h4v-4H7zm10 0h-4v4h4v-4zm0-6.001h-4V11h4V6.999zM7 11h4V6.999H7V11z" })));
}
exports.default = tombacIcon_1.default('Grid')(SvgGrid);
//# sourceMappingURL=Grid.js.map